//  Date -> Timedelta
const fromNow = (d) => d.fromNow();

export default fromNow;
